export enum SESSION_TYPE {
    DEFAULT = "DEFAULT",
    DEPOSIT = "DEPOSIT",

    TIME_REQUEST = "TIME_REQUEST",
}
